import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { EditRp } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'

export default class EditRpModal extends Component {
  static propTypes = {
    residentialProject: PropTypes.object,
    modalId: PropTypes.string
  }

  render() {
    const { residentialProject, modalId } = this.props

    const colorClass = getActivityClassName(
      get(residentialProject, 'activitySection.value')
    )

    return (
      <MaterialModal.Body
        id={modalId}
        colorClass={colorClass}
        title="Edit Residential Project"
        titleKey="moduleTitle.edit_residential_project"
      >
        <MaterialModal.Content>
          <EditRp {...this.props} colorClass={colorClass} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
